export const DEFAULT_INSURANCE_APPROVAL_SETTINGS = {
  auto_send_institutional: true,
  auto_send_pharmacy: true,
  auto_send_oral: true,
  auto_send_vision: true,
  auto_send_professional: true
}

export const normalizeInsuranceApprovalSettings = settings => ({
  ...DEFAULT_INSURANCE_APPROVAL_SETTINGS,
  ...(settings || {})
})

export const shouldAutoSendApproval = (settings, approvalType) => {
  const key = `auto_send_${approvalType}`
  return normalizeInsuranceApprovalSettings(settings)[key] !== false
}
